import React from 'react';
import { Link } from 'react-router-dom';
import './LeftMenu.less';

export default class LeftMenu extends React.Component {
    state = {
        current: ''
    }

    hover = (k) => {
        this.setState({ current: k });
    }

    checkMenus = items => {
        let flag = false;
        items.forEach(item => {
            if (item.type === 0) {
                flag = true;
                return false;
            }
        });
        return flag;
    }

    render() {
        const { displayType, menus, rootkey, active } = this.props;
        const { current } = this.state;
        return (
            <div className={'left-menu-warp ' + (displayType ? 'half' : 'all')}>
                <ul className="left-menu-ul">
                    {
                        menus && menus.length > 0 ? menus.map(item => (
                            <li
                                className={'left-menu-item ' + (current === item.id ? 'show-second-menu ' : '') + (active === item.id ? 'active' : '')}
                                onMouseOut={() => this.hover('')}
                                onMouseOver={() => this.hover(item.id)}
                                key={item.id}
                            >
                                {
                                    item.url ? <Link className="left-menu-first" to={{
                                        pathname: item.url
                                    }}>
                                        <i className={"iconfont " + (item.icon || 'icon-menu')} />
                                        <span className="left-menu-title">
                                            {item.name}
                                        </span>
                                    </Link> :
                                        <a className="left-menu-first" href='javascript:;'>
                                            <i className={"iconfont " + (item.icon || 'icon-menu')} />
                                            <span className="left-menu-title">
                                                {item.name}
                                            </span>
                                        </a>
                                }
                                {
                                    item.children ? (this.checkMenus(item.children) ?
                                        <div className={'second-menu ' + (displayType ? 'second-menu-left-half' : 'second-menu-left-all')}>
                                            <div className="second-menu-wrap">
                                                <ul className="second-menu-item">
                                                    {
                                                        item.children.map(citem => (
                                                            <li key={citem.id}>
                                                                {
                                                                    citem.url ?
                                                                        (
                                                                            citem.url.indexOf('http') !== -1 ?
                                                                                <a href={citem.url} target="_blank">
                                                                                    <span style={{ position: 'relative' }}>
                                                                                        {citem.name}
                                                                                    </span>
                                                                                </a> :
                                                                                <Link to={{ pathname: citem.url }}>
                                                                                    <span style={{ position: 'relative' }}>
                                                                                        {citem.name}
                                                                                    </span>
                                                                                </Link>
                                                                        ) :
                                                                        <a href='javascript:;'>
                                                                            <span style={{ position: 'relative' }}>
                                                                                {citem.name}
                                                                            </span>
                                                                        </a>
                                                                }
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            </div>
                                        </div> : null)
                                        : null
                                }

                            </li>
                        )) : null
                    }
                </ul>
                <div className="division-center"></div>
            </div>
        )
    }
}